var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccompagnement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 964.779,
    height: 623.836,
    viewBox: "0 0 964.779 623.836",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-469.531 -212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.609,0,19.163,1.133,21.9,19.555,0,21Z",
    transform: "translate(619 376)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.379,157.22c71.22-38.107,161.612-18.129,209.536,49.439l-1.631,1.157c-47.332-66.735-136.619-86.461-206.963-48.833a161.362,161.362,0,0,0-17.272,10.692c-72.337,51.306-89.448,151.9-38.141,224.235l-1.631,1.157c-51.944-73.237-34.622-175.08,38.615-227.024A163.742,163.742,0,0,1,692.38,157.22Z",
    transform: "translate(339.655 73.918)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069.675,320.1,835.425,301.88A13.774,13.774,0,0,1,822.775,287.1L832.93,173.283a13.774,13.774,0,0,1,14.784-12.65l234.25,18.224a13.774,13.774,0,0,1,12.65,14.784l-10.155,113.813A13.774,13.774,0,0,1,1069.675,320.1Z",
    transform: "translate(339.655 73.918)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.342,294.391q-2.667,0-5.354-.208L857.6,282.406a23.119,23.119,0,0,1-21.257-24.843l3.452-44.375A23.146,23.146,0,0,1,864.64,191.93l195.762,15.23A23.147,23.147,0,0,1,1081.659,232a67.639,67.639,0,0,1-67.317,62.389Z",
    transform: "translate(339.655 73.918)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.579,1.762,22.283,0l2.2,23.451-21.844,1.9Z",
    transform: "translate(1279.685 351)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.718,242.436l-191.906-14.93a3.054,3.054,0,0,1,.474-6.089l191.906,14.93a3.054,3.054,0,1,1-.474,6.089Z",
    transform: "translate(339.655 73.918)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.033,248.34l-113.158-8.8a3.054,3.054,0,0,1,.474-6.089l113.158,8.8a3.054,3.054,0,0,1-.474,6.089Z",
    transform: "translate(339.655 73.918)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000.96,262.383,861.94,251.567a3.054,3.054,0,0,1,.474-6.089l139.021,10.815a3.054,3.054,0,0,1-.474,6.089Z",
    transform: "translate(339.655 73.918)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054,474.6,819.75,456.38A13.774,13.774,0,0,1,807.1,441.6l10.155-113.813a13.774,13.774,0,0,1,14.784-12.65l234.25,18.224a13.774,13.774,0,0,1,12.649,14.784l-10.155,113.813A13.774,13.774,0,0,1,1054,474.6Z",
    transform: "translate(339.655 73.918)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.606,448.889q-2.629,0-5.293-.206L841.926,436.906a23.119,23.119,0,0,1-21.257-24.843l3.452-44.375a23.121,23.121,0,0,1,24.844-21.258l195.762,15.23a23.12,23.12,0,0,1,21.257,24.843,67.722,67.722,0,0,1-67.377,62.386Z",
    transform: "translate(339.655 73.918)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.043,396.936l-191.906-14.93a3.054,3.054,0,1,1,.474-6.089l191.907,14.93a3.054,3.054,0,0,1-.474,6.089Z",
    transform: "translate(339.655 73.918)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960.358,402.84l-113.158-8.8a3.054,3.054,0,1,1,.474-6.089l113.158,8.8a3.054,3.054,0,0,1-.474,6.089Z",
    transform: "translate(339.655 73.918)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.285,416.883,846.265,406.068a3.054,3.054,0,1,1,.474-6.089l139.021,10.815a3.054,3.054,0,0,1-.474,6.089Z",
    transform: "translate(339.655 73.918)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.135,415.139A56.086,56.086,0,0,1,560.76,369.854l-1.83.808a54.085,54.085,0,1,0-98.964,43.669Z",
    transform: "translate(339.655 73.918)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.929,694.185a25.6,25.6,0,0,1-3.617-19.851c.16-.652-1.007-.923-1.167-.272a26.647,26.647,0,0,0,3.81,20.654C978.347,695.328,979.318,694.794,978.929,694.185Z",
    transform: "translate(339.655 73.918)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1039.855,466.548l-13.919-74.1-27.324-35.965-20.25,13.239c2.861,15.519,24.505,44.491,24.505,44.491l19.184,57.3c-.077.3-.148.6-.2.908a10.687,10.687,0,1,0,18-5.881Z",
    transform: "translate(339.655 73.918)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.907,377.555l22.925-18.607.044-.1c4.288-9.716-5.232-26.377-13.974-38.642a19.6,19.6,0,0,0-26.223-5.3h0a19.639,19.639,0,0,0-9.131,18.613l1.928,18.562Z",
    transform: "translate(339.655 73.918)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.531,608.221H778.25l-8.221-58.836h25.506Z",
    transform: "translate(442.007 212)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.179,608.221H846.888l-9.176-58.836h28.471Z",
    transform: "translate(442.313 212)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.487,741.881c-6.277-5.971-4.645,0-22.781-7.375l-9.72,7.374h0a20.713,20.713,0,0,0-20.712,20.711v.674l53.213,0S979.764,747.852,973.487,741.881Z",
    transform: "translate(337.102 71.334)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988.826,492.877s1.781,21.374-2.672,41.857S981.7,612.9,981.7,612.9l-9.8,112.411-29.389-2.672L934.5,534.734,906,597.964l2.672,8.906-3.559,2.226s2.668,17.366.887,17.366-6.234,2.672-6.234,2.672l3.562,91.728-30.279-.891L862.365,590.84l11.577-73.917.891-14.249,4.008.165,2.041-5.953,3.748-10.242Z",
    transform: "translate(339.655 73.918)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.365,497.367l.159-.223c8.477-11.868-4.272-40.386-6.2-44.52l11.6-31.233.017-.154,3.562-31.17,5.179-20.7a45.452,45.452,0,0,0-12.9-44.048l-11.972-11.288L965.266,292.5H941.8l-8.045,15.2a34.2,34.2,0,0,0-26.46,34.916l1.823,39.855-7.138,49.623,0,8.98-6.279,17.7c-9.93,16.691-17.006,30-16.367,30.437,5.025,3.4,32.8,10.34,45.092,5.421,13.094-5.236,65.145,2.619,65.67,2.7Z",
    transform: "translate(339.655 73.918)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.324,760.728a1.186,1.186,0,0,0,1.183,1.19h280.3a1.19,1.19,0,0,0,0-2.38H787.514a1.187,1.187,0,0,0-1.19,1.183Z",
    transform: "translate(339.655 73.918)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.074,
    cy: 31.074,
    r: 31.074,
    transform: "translate(1259.084 299.318)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.526,286.053a84.516,84.516,0,0,0,14.346-1.375c4.687-1.08,15.028-9.076,17.846-13.8h0c2.094-3.51,3.351-8.938,4.036-12.874a37.779,37.779,0,0,0-7.379-29.811,11.935,11.935,0,0,0-4.925-3.989c-.174-.063-.354-.118-.534-.165a14.727,14.727,0,0,1-7.44-4.342,12.146,12.146,0,0,0-1.25-1.221,18.139,18.139,0,0,0-7.664-3.6c-4.529-1.088-11.006.275-19.253,4.054-4.143,1.9-8.742,1.369-12.286.7a1.154,1.154,0,0,0-1.076.4,8.144,8.144,0,0,1-5.476,2.349c-1.258.088-2.535,1.866-4.074,4.182-.349.526-.757,1.139-1.052,1.514l-.059-.7-.692.8a9.883,9.883,0,0,0,4.876,15.981,19.271,19.271,0,0,0,3.891.517c.795.051,1.617.1,2.407.22a14.9,14.9,0,0,1,11.318,9.38A3.9,3.9,0,0,0,939.012,256a6.438,6.438,0,0,1,5.837-1.219,4.274,4.274,0,0,1,1.944,2.093,5.571,5.571,0,0,0,2.176,2.41c3.235,1.564,3.644,8.85,2.654,14.959-.954,5.888-3.03,10.184-5.047,10.445-1.553.2-1.729.317-1.834.595l-.094.249.181.226a6.364,6.364,0,0,0,2.7.29Z",
    transform: "translate(339.655 75.918)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.789,
    cy: 61.789,
    r: 61.789,
    transform: "translate(883.885 396.564)",
    fill: "#923392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.369,375.24l-20.382-13.035c-12.979,8.977-30.519,40.6-30.519,40.6L845.076,443.82a10.681,10.681,0,1,0,11.838,14.195l61.868-43.1Z",
    transform: "translate(339.655 73.918)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.426,380.529,952,347.95l-4.91-18A19.641,19.641,0,0,0,931.85,315.89h0a19.6,19.6,0,0,0-22.536,14.418c-3.718,14.6-6.573,33.571.936,41.081l.076.076Z",
    transform: "translate(339.655 73.918)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.025,265.948l2,18.565-1.178,24.344,53.922-6.406,5.067-36.5-6.456.063Z",
    transform: "translate(445 212)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.057,603.005h14.78l7.035-45.472H144.057Z",
    transform: "translate(443.076 212)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.916,733.183l21.7-1.3v9.3l20.631,14.248a5.807,5.807,0,0,1-3.3,10.586H259.112l-4.453-9.2-1.739,9.2h-9.741Z",
    transform: "translate(339.655 69.41)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.278,603.005h14.956l7.117-45.472H210.278Z",
    transform: "translate(442 212)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.136,733.183l21.7-1.3v9.3l20.632,14.249a5.808,5.808,0,0,1-3.3,10.587H325.333l-4.453-9.2-1.739,9.2H309.4Z",
    transform: "translate(338.133 69.41)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.315,701.874h.128c-.713-79.684,1.419-106.931,5.539-180.619-7.557-48.973,28.456-80.911,28.456-80.911h53.947l11.582,39.792c7.657,74.595,6.267,147.286-5.883,217.71l.331.167c1.193.412,1.7,2.064,1.143,3.69s-1.983,2.611-3.176,2.2l-28.49-.991c-1.193-.412-1.7-2.064-1.143-3.69s1.983-2.611,3.176-2.2l1.937.98-4.131-71.345.458-13.032-.945-14.784-4.367-66.5-16.53,81.775L269.464,702.7a3.106,3.106,0,0,1-2.094,5.408H244.315a3.116,3.116,0,1,1,0-6.231Z",
    transform: "translate(339.655 73.918)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.935,
    cy: 28.935,
    r: 28.935,
    transform: "translate(597.506 328.076)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.992,413.775a94.209,94.209,0,0,1,16.532-25.79,63.662,63.662,0,0,0-9.667,30.87,48.784,48.784,0,0,0,6.6,3.453,63.262,63.262,0,0,0,21.633,4.86,94.4,94.4,0,0,1,20.269-36.034,63.814,63.814,0,0,0-9.72,35.877,99.923,99.923,0,0,0,24.341-5.217c11.808-4.062,23.271-10.129,31.437-19.565,8.838-10.213,13.194-23.69,14.6-37.126s.084-26.976-1.249-40.411c-.63-6.4,4.7-13.771,4.073-20.174h-.42c-2.8-3.842-5.658-7.778-7.033-12.333s-1.008-9.909,2.131-13.488a14.654,14.654,0,0,1,6.434-3.989c.231-.294.483-.577.745-.861a59.842,59.842,0,0,1,16.532-12.365c-4.461,3.369-7.442,7.18-8.828,11.116q5.794-1.275,11.588-2.54a55.824,55.824,0,0,1,4.073-3.9c2.068-1.795,2.75-1.931,5.217-3.621a16.644,16.644,0,0,0-4.5,6.424c4.965-1.249,9.93-3.128,12.512-7.4,4.283-7.064-.808-16.595-7.914-20.814a28.316,28.316,0,0,0-32.885,3.621c-10.276-7.568-24.908-7.442-36.339-1.784a53.134,53.134,0,0,0-18.957,16.49,74.149,74.149,0,0,1,8.586-.6,26.332,26.332,0,0,0-11.242,4.45,77.434,77.434,0,0,0-4.073,7.127q-1.212,2.409-2.288,4.881c-4.4,10.014-7.264,20.678-10.234,31.216-3.464,12.281-7.18,24.646-13.666,35.635a80.038,80.038,0,0,1-44.137,35.216C142.6,390.882,149.38,404.464,159.992,413.775Z",
    transform: "translate(339.655 76.918)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.924,332.565l-5.616-2.76-7.082-14.985L278,317.518l-6.131,16.067L257.1,348.346l6.459,44.518,10.035,54.076,67.177-10.989-.071-40.707s12.139-32.161-7.47-44.212Z",
    transform: "translate(339.655 73.918)",
    fill: "#923392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.471,436.28a9.612,9.612,0,0,1-12.991-6.962L331.578,384l13.691-15.8,69.321,49.518a9.664,9.664,0,0,1,4.881,18.563Z",
    transform: "translate(339.655 73.918)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.619,362.5s-3.58,3.6,5.4,9.524c7.191,4.741,39.264,28.17,50.633,31.876a7.551,7.551,0,0,0,5.033,7.77l10.294-22.622c-2.228-5.172-5.793-3.974-7.668-2.8l-12.433-9.35-30.53-30.486-18.191,13.441Z",
    transform: "translate(339.655 73.918)",
    fill: "#923392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.675,245.149a40.3,40.3,0,0,0-4.848,35.414",
    transform: "translate(339.655 76.918)",
    fill: "#fd6584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.876,760.728a1.186,1.186,0,0,0,1.19,1.19h280.29a1.19,1.19,0,1,0,0-2.38H131.066a1.187,1.187,0,0,0-1.19,1.19Z",
    transform: "translate(339.655 73.918)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.666,490.254a2.8,2.8,0,0,0-1.711,3.56l39.05,112.55a2.8,2.8,0,0,0,3.56,1.711l227.22-79.722a2.8,2.8,0,0,0,1.711-3.561l-39.05-112.55a2.8,2.8,0,0,0-3.561-1.711Z",
    transform: "translate(339.655 73.918)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.179,591.832a21.649,21.649,0,0,1-20.4-14.41l-21.445-60.676a21.612,21.612,0,0,1,13.174-27.578l114.839-40.589a86.06,86.06,0,0,1,109.7,52.4,21.612,21.612,0,0,1-13.174,27.578l-.167-.472.167.472L301.36,590.6a21.532,21.532,0,0,1-7.181,1.236Z",
    transform: "translate(339.655 73.918)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.469,472.227,343.641,508.3c-1.449.508-3.244-.85-4.011-3.034s-.213-4.366,1.236-4.874l102.828-36.078c1.449-.508,3.244.85,4.011,3.034S447.918,471.72,446.469,472.227Z",
    transform: "translate(339.655 73.918)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.422,494.9,351.594,530.974c-1.449.508-3.244-.85-4.011-3.034s-.213-4.366,1.236-4.875l102.828-36.078c1.449-.508,3.244.85,4.011,3.034S455.871,494.388,454.422,494.9Z",
    transform: "translate(339.655 73.918)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.949,583.573",
    transform: "translate(339.655 73.918)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.727,520.638a27.578,27.578,0,0,1,1.584,9.7,26.816,26.816,0,0,1-.446,4.5,27.706,27.706,0,0,1-45.329,16.021q-.56-.479-1.091-.989a27.7,27.7,0,1,1,45.282-29.231Z",
    transform: "translate(339.655 73.918)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.295,
    cy: 5.295,
    r: 5.295,
    transform: "translate(639.124 597.428)",
    fill: "#fd6584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.445,549.869c1.359-3.155,2.966-7.968,6.688-6.216,1.839.8,5.132,3.219,6.469.4l10.47-21.916A3.41,3.41,0,0,1,312.7,520.6l18.613,9.738a26.833,26.833,0,0,1-.446,4.5l-45.329,16.021Z",
    transform: "translate(339.655 73.918)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.848,485.147a9.612,9.612,0,0,1-4.725-13.961l-23.7-84.279,20.79-2.172,16.755,83.527a9.664,9.664,0,0,1-9.125,16.886Z",
    transform: "translate(339.655 73.918)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.922,340.642s-5.075.182-2.566,10.644c2.008,8.376,9.383,60.917,15.149,71.393a7.551,7.551,0,0,0-1.637,9.112l22.977-9.477c1.908-5.3.431-10.108-1.74-10.534l-2.684-15.323-3.956-51.4-21.877-4.608Z",
    transform: "translate(339.655 73.918)",
    fill: "#923392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.9,562.391l-31.776,1.316a4.5,4.5,0,0,1-3.6-1.555,4.408,4.408,0,0,1-1.017-3.707,86.535,86.535,0,0,0-2.075-39.953,4.471,4.471,0,0,1,2.208-5.227c13.015-6.762,25.211-7.105,36.246-1.02a4.527,4.527,0,0,1,2.272,3.06,141.552,141.552,0,0,1,2.042,43.032A4.491,4.491,0,0,1,464.9,562.391Z",
    transform: "translate(339.655 73.918)",
    fill: "#923392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.557,541.593l-24.3,1.006a2.281,2.281,0,0,1-.189-4.558l24.3-1.006a2.281,2.281,0,0,1,.189,4.558Z",
    transform: "translate(339.655 73.918)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.226,533.6l-24.3,1.006a2.281,2.281,0,0,1-.189-4.558l24.3-1.006a2.281,2.281,0,0,1,.189,4.558Z",
    transform: "translate(339.655 73.918)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.059,313.818l-31.534-4.136a4.5,4.5,0,0,1-3.283-2.148,4.408,4.408,0,0,1-.368-3.826,86.534,86.534,0,0,0,4.786-39.719,4.471,4.471,0,0,1,3.069-4.772c13.98-4.437,26.055-2.69,35.887,5.191a4.526,4.526,0,0,1,1.715,3.4,141.551,141.551,0,0,1-5.345,42.748,4.491,4.491,0,0,1-4.926,3.259Z",
    transform: "translate(339.655 73.918)",
    fill: "#923392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.29,293.1l-24.111-3.162a2.281,2.281,0,1,1,.593-4.523l24.111,3.162a2.281,2.281,0,0,1-.593,4.523Z",
    transform: "translate(339.655 73.918)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.33,285.165,1025.219,282a2.281,2.281,0,0,1,.593-4.523l24.111,3.162a2.281,2.281,0,0,1-.593,4.523Z",
    transform: "translate(339.655 73.918)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.019,374.936h-10.5v-10.5a9.5,9.5,0,0,0-19,0v10.5h-10.5a9.5,9.5,0,0,0,0,19h10.5v10.5a9.5,9.5,0,1,0,19,0v-10.5h10.5a9.5,9.5,0,0,0,0-19Z",
    transform: "translate(339.655 73.918)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.011,
    cy: 10.011,
    r: 10.011,
    transform: "translate(1295.698 234.512)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.011,
    cy: 10.011,
    r: 10.011,
    transform: "translate(680.698 517.512)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.487,741.881c-6.277-5.971-4.645,0-22.781-7.375l-9.72,7.374h0a20.713,20.713,0,0,0-20.712,20.711v.674l53.213,0S979.764,747.852,973.487,741.881Z",
    transform: "translate(268.102 71.334)",
    fill: "#090814"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccompagnement);
export default __webpack_public_path__ + "static/media/accompagnement.1a3cd5afa24635ca832b50975271c687.svg";
export { ForwardRef as ReactComponent };